import { render, staticRenderFns } from "./leader.vue?vue&type=template&id=b0954b1e&scoped=true&"
import script from "./leader.vue?vue&type=script&lang=js&"
export * from "./leader.vue?vue&type=script&lang=js&"
import style0 from "./leader.vue?vue&type=style&index=0&id=b0954b1e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0954b1e",
  null
  
)

export default component.exports